module.exports = __webpack_public_path__ + "img/PL08485.631c5d13.png";